<template>
  <div class="pa-16">
    <v-container>
      <p class="text-h5 mb-10">
        {{ $t('COMMON.COPYWRITING.CANT_FIND_THIS_PAGE') }}
      </p>
    </v-container>
  </div>
</template>

<script>
export default {
  created() {
    this.$router.replace('/404');
  }
};
</script>

<style lang="scss" scoped>
//
</style>